import { Controller } from "@hotwired/stimulus"

// Persists <details> open/close state in localStorage
export default class extends Controller {
  static values = { key: String }

  connect() {
    this._restoring = true
    const stored = localStorage.getItem(this._storageKey)
    if (stored === "closed") {
      this.element.removeAttribute("open")
    } else if (stored === "open") {
      this.element.setAttribute("open", "")
    }
    // Allow toggle events after restoration is complete
    requestAnimationFrame(() => { this._restoring = false })
  }

  toggle() {
    if (this._restoring) return
    localStorage.setItem(this._storageKey, this.element.open ? "open" : "closed")
  }

  get _storageKey() {
    return `sidebar_section_${this.keyValue}`
  }
}
